import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {CircularProgress} from 'material-ui/Progress'

// TODO add story

const styles = theme => ({
  wrapper: {
    position: 'relative',
  },
  indicator: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'rgba(247, 247, 247, .65)',
    borderRadius: 5,
  },
})

const LoadingIndicator = ({classes, children, show = false, noBackDrop = false, ...props}) => (
  <div className={classes.wrapper} {...props}>
    {children}
    {show === true ? (
      <div className={classes.backdrop} style={{background: noBackDrop ? 'rgba(0,0,0,0)' : undefined}}>
        <CircularProgress
          size={24}
          className={classes.indicator}
        />
      </div>
    ) : null}
  </div>
)

LoadingIndicator.propTypes = {
  children: PropTypes.any.isRequired,
  show: PropTypes.bool,
  noBackDrop: PropTypes.bool,
}

export default withStyles(styles, {withTheme: true})(LoadingIndicator)



// WEBPACK FOOTER //
// ./src/components/loadingIndicator.jsx